// extracted by mini-css-extract-plugin
export default {"products":"Pz-z","card":"Qz-z","oosMessaging":"Rz-z"};